import React from 'react';
import { Link, useNavigate, useResolvedPath } from 'react-router-dom';
//import 'bulma/css/bulma.min.css';
import './CustomStyles.css';
import MuayThaiBeatsIcon from './images/Muay_Thai_Beats_Icon.png';
import BannerLeft from './images/banner_left.png';
import BannerRight from './images/banner_right.png';

function AboutUs() {
  const navigate = useNavigate();
  const basePath = useResolvedPath('').pathname; // Dynamically resolve the current path

  return (
    <div className="about-us-page">
      {/* Main AboutUs Banner */}
      <section className="hero-banner">
        <div className="banner-container">
          {/* Muay Thai Beats Icon */}
          <div
            className="icon-link"
            onClick={() => navigate(`${basePath}/melding-muaythai-music`)}
            role="button"
            tabIndex={0}
          >
            <img
              src={MuayThaiBeatsIcon}
              alt="Muay Thai Beats Icon"
              className="icon-overlay"
            />
          </div>

          {/* Banner Left: About Muay Thai */}
          <div
            className="banner-left-link"
            onClick={() => navigate(`${basePath}/about-muaythai`)}
            role="button"
            tabIndex={0}
          >
            <img
              src={BannerLeft}
              alt="Muay Thai Training"
              className="banner-left"
            />
          </div>

          {/* Banner Right: About Music */}
          <div
            className="banner-right-link"
            onClick={() => navigate(`${basePath}/about-music`)}
            role="button"
            tabIndex={0}
          >
            <img
              src={BannerRight}
              alt="Music Training"
              className="banner-right"
            />
          </div>
        </div>
      </section>

      <nav className="about-mobile-navigation" aria-label="About Muay Thai Beats">
        <Link
          className="about-mobile-destination"
          to={`${basePath}/about-muaythai`}
        >
          <img
            className="about-mobile-destination-image"
            src={BannerLeft}
            alt="Muay Thai training"
          />
          <span className="about-mobile-destination-shade" aria-hidden="true" />
          <span className="about-mobile-destination-copy">
            <span className="about-mobile-destination-kicker">The fight side</span>
            <strong>ABOUT MUAY THAI</strong>
            <span className="about-mobile-destination-arrow" aria-hidden="true">→</span>
          </span>
        </Link>

        <Link
          className="about-mobile-destination"
          to={`${basePath}/about-music`}
        >
          <img
            className="about-mobile-destination-image"
            src={BannerRight}
            alt="DJ and music equipment"
          />
          <span className="about-mobile-destination-shade" aria-hidden="true" />
          <span className="about-mobile-destination-copy">
            <span className="about-mobile-destination-kicker">The music side</span>
            <strong>ABOUT DJING</strong>
            <span className="about-mobile-destination-arrow" aria-hidden="true">→</span>
          </span>
        </Link>

        <Link
          className="about-mobile-destination about-mobile-destination-community"
          to={`${basePath}/melding-muaythai-music`}
        >
          <span className="about-mobile-community-art" aria-hidden="true">
            <img src={BannerLeft} alt="" />
            <img src={BannerRight} alt="" />
            <img
              className="about-mobile-community-logo"
              src={MuayThaiBeatsIcon}
              alt=""
            />
          </span>
          <span className="about-mobile-destination-shade" aria-hidden="true" />
          <span className="about-mobile-destination-copy">
            <span className="about-mobile-destination-kicker">Why bring them together?</span>
            <strong>BUILDING A COMMUNITY</strong>
            <span className="about-mobile-destination-arrow" aria-hidden="true">→</span>
          </span>
        </Link>
      </nav>

      {/* Nested Routes for Subpages */}
      {/* <Routes>
        <Route path={`${basePath}/about-muaythai`} element={<AboutMuayThai />} />
        <Route path={`${basePath}/about-music`} element={<AboutMusic />} />
        <Route path={`${basePath}/melding-muaythai-music`} element={<MeldingPage />} />
      </Routes> */}
    </div>
  );
}

export default AboutUs;


/*
  <section className="custom-margin blog-content">

        <h1>About Us - Muay Thai Beats</h1>
        <p>Welcome to Muay Thai Beats!</p>
        <p>
          We are a unique club that combines the art of Muay Thai with the energy and rhythm of music. Our innovative approach leverages the power of beats and tempos to enhance the training experience, making it both effective and enjoyable.
        </p>
        <h2>Our Vision</h2>
        <p>
          Our vision is to make Muay Thai more accessible and engaging by integrating music into the training process. We believe that music can provide a structured and fun way to learn and practice Muay Thai.
        </p>
        <h2>The Concept</h2>
        <h3>Using Music to Guide Muay Thai Training</h3>
        <p>
          Imagine training Muay Thai to the rhythm of a house song, where the beats dictate your movements and combinations. We use a DJ controller to mix a house song with a variable BPM &#40;beats per minute&#41; and a track of vocal instructions that guide you through different combos.
        </p>
        <h3>How It Works:</h3>
        <ul>
          <li>Dual Channel Mixing: We mix a house beat &#40;channel one&#41; with vocal instructions &#40;channel two&#41;.</li>
          <li>Call and Response: The vocals provide the call &#40;e.g., jab-jab-cross&#41;, and the music responds with an associated combo in the next musical phrase.</li>
          <li>Incremental BPM: We start with a slower BPM to help members familiarize themselves with the strikes and combos. As members get more comfortable, we increase the BPM to match their skill level, promoting muscle memory and correct technique.</li>
        </ul>
        <h3>Combos Translated to Music:</h3>
        <ul>
          <li>Call: The actual name of the strikes &#40;e.g., jab, cross, hook&#41; said on beat.</li>
          <li>Response: The numbered version of the strike overlayed with music elements &#40;e.g., chord progression, drums, 808s&#41;.</li>
        </ul>
        <h3>Musical Elements:</h3>
        <ul>
          <li>Hi-hats: Represent jabs.</li>
          <li>Snare: Represents crosses or hooks.</li>
          <li>Kicks: Represent quick strikes.</li>
        </ul>
        <h2>Why Muay Thai Beats?</h2>
        <ul>
          <li>Accessible Training: You don&#39;t have to be a seasoned fighter to enjoy and benefit from our sessions. The music guides your movements, making it easier to follow along.</li>
          <li>Fun Learning Experience: Training with music adds a fun element to the workout, keeping you motivated and engaged.</li>
          <li>Effective Workouts: The structured approach helps in building good habits, ensuring you practice proper form and technique.</li>
        </ul>
        <p>
          Join us at Muay Thai Beats and experience a revolutionary way to train. Whether you&#39;re a beginner or a seasoned fighter, our sessions are designed to help you improve your skills while having a great time.
        </p>
        <h3>Contact Us:</h3>
        <p>
          For more information about our club and session timings, please contact us at &#91;your contact information&#93;.
        </p>
      </section>
*/
